import { GoodToKnow as G2K, CardSize, TranslationProvider, TrackingProvider } from '@eventbrite/good-to-know';
import { useRef } from 'react';
import { useIntl } from 'react-intl';
import type { WebappResponse } from '@eventbrite/event-listing-service-client';
import { getTranslations } from './translations';
import { useGoodToKnowData } from '@/components/GoodToKnow/useGoodToKnowData';
import { track } from '@eventbrite/legacy-infra.datalayer-library';
import { LISTING_HEAP_IDS } from '@/components/_shared/constants';
import styles from './GoodToKnow.module.scss';

// TODO: Move this props into their own context provider
export const GoodToKnow: React.FC<NonNullable<WebappResponse['goodToKnow']>> = ({ highlights, refundPolicy }) => {
  const { locale, messages } = useIntl();

  const { dHighlights, translatedRefundPolicy, location } = useGoodToKnowData(highlights, refundPolicy);

  const g2kRef = useRef<HTMLDivElement>(null);

  return (
    <TrackingProvider
      data-testid="g2k-container"
      onSectionVisible={(sectionKey: string) => {
        track({
          eventName: LISTING_HEAP_IDS.G2K_VIEW_CARD,
          eventData: {
            card_key: sectionKey,
          },
        });
      }}
      onReadMoreClick={(sectionKey: string) => {
        track({
          eventName: LISTING_HEAP_IDS.G2K_READ_MORE_CLICK,
          eventData: {
            card_key: sectionKey,
          },
        });
      }}
    >
      <TranslationProvider translations={getTranslations(location, locale, messages)}>
        <div className={styles.g2k}>
          <G2K
            highlights={dHighlights}
            refundPolicy={translatedRefundPolicy || ''}
            cardSize={refundPolicy ? CardSize.STRETCHED : CardSize.CONTAINED}
            showViewAll={false}
          />
          <div ref={g2kRef} />
        </div>
      </TranslationProvider>
    </TrackingProvider>
  );
};
